import _ from "lodash";

export const SitePaths = [
  "logoutsaml",
  "passwordlessLogin",
  "dashboard",
  "my-support",
  "my-account-team",
  "my-addresses",
  "noprofile",
  "invalidurl",
  "register",
  "knowledgebase",
  "my-company",
  "support-center",
  "logincomplete",
  "callback",
  "logout",
  "settings",
  "attachment",
  "manageclients",
  "kb-admin",
  "demos",
  "knowledgebase",
  "shi",
  "shi-internal",
  "shi-internal/propensity",
  "shi-internal/renewal",
  "assets-dashboard",
  "assets",
  "warehouse",
  "cart",
  "checkout",
  "orders",
  "invoices",
  "quotes",
  "integration-center",
  "api",
  "welcome",
  "welcomeCallback",
  "",
  "userprofile",
  "organizationprofile",
  "services",
  "successplan",
  "assessments",
  "projects",
  // unused but reserved:
  "cloud",
  "shione",
  "shi1",
  "sh1",
  "shicorp",
  "shient",
  "home",
  "support",
  "faq",
  "dashboards",
  "help",
  "blog",
  "news",
  "store",
  "shop",
  "admin",
  "cost-centers",
  "cisco",
  "support-centerV2",
  "labs",
  "valuestreams",
  "customersuccess",
  "success",
  "cloud-marketplace",
  "customer-experience-support-dashboard",
  "customer-experience-services-dashboard",
  "report-center",
  "message-center",
  "manufacturer-insights",
  "roadmaps",
  "catalyst",
  "recommendations",
  "planning",
  "standards-shop",
  // SPU-787: without these, a deep link to a routed overlay redirects to /invalidurl on full page load.
  "standards-management",
  "service-catalog",
  "internal",
  // cXML punchout storefront and its admin app (SPU-657), so no customer can claim them as their custom URL.
  "punchout",
  "punchout-admin",
];
export const AppendIfPrefixExists = (path: string): string => {
  const pathNames =
    window.location.pathname[0] === "/"
      ? window.location.pathname.substring(1).split("/")
      : window.location.pathname.split("/");
  const isBaseSite = _.includes(SitePaths, pathNames[0]);

  // Don't prefix an absolute path or if we're on the base site.
  if (isBaseSite || path.startsWith("http") || path.startsWith("https")) {
    return path;
  } else {
    return "/" + pathNames[0] + path;
  }
};
